import { IControlOption } from '@/Interfaces/ControlOption.interface';
import UserIcon from '@/components/Icons/UserIcon';
import { MenuItem, Select, SelectChangeEvent, inputBaseClasses } from '@mui/material';
import { useCallback, useState } from 'react';

interface IProps {
  options: IControlOption[];
  onChange: (value: number) => void;
}

const AdvertiserSelect = ({ options, onChange }: IProps) => {
  const [selectedValue, setSelectedValue] = useState<string>('');

  const onSelectOption = useCallback(
    (e: SelectChangeEvent) => {
      const newValue = e.target.value;
      setSelectedValue(newValue);
      onChange(+newValue);
    },
    [onChange, setSelectedValue],
  );

  return (
    <Select
      value={selectedValue}
      startAdornment={<UserIcon />}
      displayEmpty
      onChange={onSelectOption}
      renderValue={selected => {
        if (!selected) return 'Select Advertiser';
        const option = options.find(opt => opt.value === Number(selected));
        return option ? option.label : 'Select Advertiser';
      }}
      sx={{
        backgroundColor: '#FFF',
        height: '45px',
        minWidth: '200px',
        [`& .${inputBaseClasses.input}`]: {
          fontSize: 14,
          fontWeight: 600,
        },
      }}
      slotProps={{
        paper: { className: 'mt-2' },
      }}
      fullWidth
    >
      {options.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default AdvertiserSelect;
